var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logobar" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "router-link",
          { staticClass: "logo", attrs: { to: _vm.logoTo } },
          [
            _vm.currentCategoryImage
              ? [
                  _c("img", {
                    staticClass: "logo-category-img",
                    attrs: {
                      src: _vm.currentCategoryImage,
                      alt: _vm.currentCategoryName,
                    },
                  }),
                ]
              : _vm.shopLogo
              ? [_c("img", { attrs: { src: _vm.shopLogo, alt: _vm.appName } })]
              : [
                  _c("img", {
                    attrs: {
                      src: "/assets/img/header/header-bi.svg",
                      alt: _vm.appName,
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: "/assets/img/header/header-logo.svg",
                      alt: _vm.appName,
                    },
                  }),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-actions d-flex d-md-none align-center" },
          [
            _vm.$route.name !== "Login"
              ? _c(
                  "router-link",
                  {
                    staticClass: "mobile-icon-btn",
                    attrs: { to: "/cart" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeMenu.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "las la-shopping-cart" }),
                    _vm._v(" "),
                    _vm.getCartCount > 0
                      ? _c("span", { staticClass: "mobile-cart-badge" }, [
                          _vm._v(_vm._s(_vm.getCartCount)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "hamburger-btn",
                class: { open: _vm.isActiveMenu },
                on: { click: _vm.toggleActiveMenu },
              },
              [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isActiveMenu,
            expression: "isActiveMenu",
          },
        ],
        staticClass: "mobile-menu",
      },
      [
        _c("div", { staticClass: "menu-wrapper" }, [
          _c(
            "ul",
            { staticClass: "menu-list1" },
            _vm._l(_vm.menuItems, function (item, i) {
              return _c(
                "li",
                {
                  key: i,
                  class: { active: _vm.currMenu === i },
                  on: {
                    click: function ($event) {
                      _vm.currMenu = i
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.menuItems[_vm.currMenu] &&
          _vm.menuItems[_vm.currMenu].children &&
          _vm.menuItems[_vm.currMenu].children.length
            ? _c(
                "ul",
                { staticClass: "menu-list2" },
                _vm._l(_vm.menuItems[_vm.currMenu].children, function (sub, j) {
                  return _c(
                    "li",
                    {
                      key: j,
                      class: {
                        h: sub.badge === "h",
                        n: sub.badge === "n",
                        b: sub.badge === "b",
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: sub.href || "/" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeMenu.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "h-icon" }, [_vm._v("H")]),
                          _vm._v(" "),
                          _c("i", { staticClass: "n-icon" }, [_vm._v("N")]),
                          _vm._v(" "),
                          _c("i", { staticClass: "b-icon" }, [_vm._v("B")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(sub.name) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm.menuItems[_vm.currMenu] && _vm.menuItems[_vm.currMenu].href
            ? _c("ul", { staticClass: "menu-list2 no-sub" }, [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: _vm.menuItems[_vm.currMenu].href },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.closeMenu.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("바로가기")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-menu-footer" },
          [
            !_vm.isAuthenticated
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn-login",
                    attrs: {
                      to: _vm.shopSlugForLogin
                        ? {
                            name: "Login",
                            query: { shop_id: _vm.shopSlugForLogin },
                          }
                        : { name: "Login", query: {} },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeMenu.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "las la-sign-in-alt" }),
                    _vm._v(" 로그인\n            "),
                  ]
                )
              : [
                  _vm.isUseAfterLogin
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-mypage",
                          attrs: { href: _vm.homeHref },
                          on: { click: _vm.closeMenu },
                        },
                        [
                          _c("i", { staticClass: "las la-home" }),
                          _vm._v(" 홈\n                "),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn-mypage",
                      attrs: { to: { name: "DashBoard" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMenu.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "las la-user" }),
                      _vm._v(" 마이페이지\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn-logout", on: { click: _vm.logout } },
                    [
                      _c("i", { staticClass: "las la-sign-out-alt" }),
                      _vm._v(" 로그아웃\n                "),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }